// extracted by mini-css-extract-plugin
module.exports = {"overlay":"overlay--fscyx","modal":"modal--fEUzZ","suffix":"suffix--zP5hj"};